import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export default function MissionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="mission"
      className="py-14 md:py-20 bg-[#EAFCEF] w-full"
      ref={ref}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-8">
            Our Mission
          </h2>
          <p className="text-2xl md:text-3xl text-gray-800 mb-8 font-medium">
            We exist to make global education accessible, transparent, and
            empowering.
          </p>
          <p className="text-base md:text-xl font-medium text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Every year, millions of students dream of studying abroad but face
            barriers that shouldn't exist. We're building the infrastructure to
            remove those barriers, providing clear pathways, trusted
            partnerships, and personalized guidance that transforms dreams into
            reality.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
